<div class="user">
  <div class="user__picture">
    {{ username?.charAt(0) | uppercase }}
  </div>
  <!-- <div class="user__info">
    <div class="user__name">
      {{ username | titlecase }}
    </div>
  </div> -->
</div>